module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABHklEQVRYR+3XMY7CMBAF0D+3YEVBhcQ1tqChWI4xVk5k5xZUaKs9BxSLRLNcwjFyFyUhmdiTiJWSOhm/fFseDeFNHnoTBxZIcydaiZRl+VVVlSOilXTbmFmUrLV2S0RnADdm3tfrtwpYa//GIGIxCSQiAPwQ0TqEcDHG7HohzrkgLS5NrI4AcPfefxZF8TsrRIKIoNbWaCYiRUwKGYOYDDIWMQkkBaEOSUWoQnIQapBchApEA5EN0UJkQVIRry7MpJs1FRH/XBXinLsCiN20s4H1NUNtyDeAjff+0OyiQx1ZFTK02GyJLJCcBJrfLmfk/yeSMk4knKEHM38MzTVHAHbsbCPFhBAeAIwx5tQLkRbUfk80Kmov2lVvgTRTeQL7QTAy1e2gHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-update.png
// module id = 4mUw
// module chunks = 4